import { Box, CheckCircleIcon, HStack, Text } from 'native-base';
import React, { memo } from 'react';
import { CircleCrossIcon } from '../../assets';
import { ContextProvider } from '../../utils';
const Toast = props => {
  const {
    message,
    toastType
  } = props;
  return /*#__PURE__*/React.createElement(ContextProvider, null, /*#__PURE__*/React.createElement(HStack, {
    space: 2,
    borderRadius: 4,
    background: toastType === 'SUCCESS' ? '#03906a26' : '#d63d3426',
    p: 6,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, null, toastType === 'SUCCESS' && /*#__PURE__*/React.createElement(CheckCircleIcon, {
    color: '#03906A',
    size: 6
  }), toastType === 'ERROR' && /*#__PURE__*/React.createElement(CircleCrossIcon, null)), /*#__PURE__*/React.createElement(Text, {
    color: "text.running",
    fontSize: "sm",
    accessibilityLabel: `${toastType}-${message}`,
    accessibilityRole: "text",
    testID: `${toastType}-${message}`
  }, message)));
};
export default /*#__PURE__*/memo(Toast);
//# sourceMappingURL=Toast.js.map